import React from 'react'

/** Secondary tenant label shown beside the platform wordmark in the app header. */
export const TenantHeaderLabel: React.FC<{ label: string }> = ({ label }) => {
  if (!label.trim()) return null

  return (
    <>
      <span className="brand-mark__divider" aria-hidden="true" />
      <span className="brand-mark__companion" title={label}>
        {label}
      </span>
    </>
  )
}

export default TenantHeaderLabel
